/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type StatusWithDescription_projectStatus = {
    readonly id: string;
    readonly person: {
        readonly id: string;
        readonly fullName: string | null;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
    } | null;
    readonly description: string | null;
    readonly color: string | null;
    readonly day: number | null;
    readonly month: number | null;
    readonly year: number | null;
    readonly " $refType": "StatusWithDescription_projectStatus";
};
export type StatusWithDescription_projectStatus$data = StatusWithDescription_projectStatus;
export type StatusWithDescription_projectStatus$key = {
    readonly " $data"?: StatusWithDescription_projectStatus$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StatusWithDescription_projectStatus">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StatusWithDescription_projectStatus",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePictureId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePictureDefaultId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "month",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "year",
      "storageKey": null
    }
  ],
  "type": "ProjectStatus"
};
})();
(node as any).hash = '50e9065648a698fab579adfa21103907';
export default node;
